import { LinkedResource } from '../../types'
import { ExternalLink } from 'lucide-react'

interface LinkedResourcesProps {
  resources: LinkedResource[]
}

export const LinkedResources = ({ resources }: LinkedResourcesProps) => {
  return (
    <>
      {resources.map((resource, index) => (
        <a
          key={index}
          className="bg-primary-white w-full rounded-2xl p-3 gap-4 flex justify-between items-center"
          href={resource.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <p>{resource.label}</p>
          <ExternalLink className="text-primary-black shrink-0 ml-2" />
        </a>
      ))}
    </>
  )
}